// extracted by mini-css-extract-plugin
export default {"background":"Process_background__Q38DR","content":"Process_content__THTeQ","cards":"Process_cards__FDRTG","card":"Process_card__0fKwV"};